// package imports
import { useSimpleList } from '@refinedev/antd';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { Card, Empty } from 'antd';
// project imports
import apiEndpoint from 'core/common/apiEndPoints';

import directFileDownload from 'core/utils/directFileDownload';
import { useTranslate } from '@refinedev/core';
import TreeNode from 'pages/unificationList/unificationTreeNode';
import TitleCard from 'core/utils/titleCard';
import resourceName from 'core/common/resourceName';

const UnificationHistoryShow = () => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const t = useTranslate();
  const navigate = useNavigate();
  const { listProps } = useSimpleList({
    resource: `${apiEndpoint.unificationHistoryTree}/${id}`,
    dataProviderName: 'unifiedDataProvider',
    queryOptions: {
      enabled: !!id,
    },
    pagination: {
      mode: 'off',
    },
    syncWithLocation: false,
  });

  const onFinishHandler = async (node) => {
    const startDate = searchParams.get('startDate');
    const endDate = searchParams.get('endDate');
    let apiUrl;
    console.log('node', node);
    if (
      node.parent_source_type === 'unified' ||
      node.source_type === 'unified'
    ) {
      apiUrl = `${apiEndpoint.downloadUnifiedFile}/?unification_run_master_id=${searchParams.get('unificationRunMasterId')}&unified_source_master_id=${node.unique_id}`;
    } else if (node.source_type === 'input') {
      apiUrl = `${apiEndpoint.inputFIleDownloads}/?input_source_id=${node.unique_id}&unification_run_master_id=${searchParams.get('unificationRunMasterId')}`;
    } else {
      const dateRange = `${startDate} - ${endDate}`;
      apiUrl = `${apiEndpoint.unificationDownload}/?source_type=${node.source_type}&source_id=${node.unique_id}&transaction_date_range=${dateRange}`;
    }
    await directFileDownload(apiUrl);
  };

  const unificationStructureData = listProps?.dataSource;

  return (
    <>
      <TitleCard
        config={{
          title: t('pages.unificationTreeShowTitle.title'),
          onClick: () => {
            navigate(`/${resourceName.unificationHistory}`);
          },
        }}
      />
      <Card className="mt-4">
        <div className="tree">
          {unificationStructureData ? (
            <TreeNode
              node={unificationStructureData}
              onFinishHandler={onFinishHandler}
            />
          ) : (
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
          )}
        </div>
      </Card>
    </>
  );
};

export default UnificationHistoryShow;
